<script setup>
import { onMounted, watch } from 'vue'
import axios from 'axios'
import { cloneDeep } from 'lodash'
import { useMainStore } from './stores/main-store'
import ShopLayout from './components/ShopLayout.vue'
import ProductFilter from './components/ProductFilter.vue'
import CurrentFilters from './components/CurrentFilters.vue'

const mainStore = useMainStore()

// eslint-disable-next-line no-undef
const object = vnObject

onMounted(async () => {
  // eslint-disable-next-line no-undef
  const themeObject = vnObject

  await axios
    .get(themeObject.productApi)
    .then((response) => {
      mainStore.apiData = { ...themeObject, ...response.data.body }

      if (!Object.keys(mainStore.categorySections).length) {
        mainStore.categorySections = cloneDeep(response.data.body.products)
      }
    })
    .catch((error) => {
      this.error.show = true
      this.error.message = error.response.data.message
    })
})

watch(
  () => mainStore.hasFilter,
  (newVal) => {
    if (newVal === false) {
      mainStore.categorySections = cloneDeep(mainStore.apiData.products)
    }
  }
)
</script>

<template>
  <template v-if="mainStore?.apiData?.products?.length">
    <ProductFilter />
    <CurrentFilters />
    <div class="shop">
      <ShopLayout />
    </div>
  </template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-else class="main-loader" v-html="object.loader"></div>
</template>

<style lang="scss">
@import './scss/app';
</style>
